import { unichain as viemUnichain } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const unichain = {
  displayName: 'Unichain',
  runtime: 'evm',
  viemChain: viemUnichain,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 8,

  decoration: {
    color: '#F50DB4',
    contrastColor: getContrastColor('#F50DB4'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'unichain-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://uniscan.xyz',
        token: 'https://uniscan.xyz/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    lifi: { chainKey: 'UNI' },
    stargate: { chainKey: 'unichain' },
    across: { chainKey: 'unichain' },
    kyberswap: { chainKey: 'unichain' },
  }),
  services: defaultServices({
    codex: {
      networkId: 130,
      nativeLiquidityAddress: '0x4200000000000000000000000000000000000006',
    },
    defiLlama: { chainKeys: ['unichain'] },
    trm: { chainKey: 'unichain' },
    zerion: { chainKey: 'unichain' },
    coingecko: {
      networkId: 'unichain',
      platformId: 'unichain',
    },
    coingeckoDex: {
      networkId: 'unichain',
    },
    qnStreams: {
      networkKey: 'unichain-mainnet',
    },
    safe: { shortName: 'unichain' },
    alchemy: { chainSlug: 'unichain-mainnet' },
    pimlico: { chainSlug: 'unichain' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
